module.exports = __webpack_public_path__ + "static/media/men_brainstorm2.88209c9b.png";